// services/owner-services/owner-property-services.js
import apiClient from "../axios.config";

const ownerPropertyServices = {
  getProperty(propertyGuid) {
    return apiClient.get(`/owner/properties/${propertyGuid}`);
  },
  // this api used to get  the property flats  Report like Who occupied from  - to dates
  getFlatOccupancyReport(payload)
  {
    return apiClient.post("owner/properties/flats-occuapancy-report",payload)
  },

};






export default ownerPropertyServices;
